import { fetchCurrentUser } from '../../../@mrkt/useCurrentUser';
import { setState } from './root';

const key = 'me';

export const loadMe = () => async dispatch => {
  const me = await fetchCurrentUser();
  dispatch(
    setState({
      type: `${key}/LOAD`,
      payload: {
        [key]: me ? { ...me, loaded: true } : null,
      },
    }),
  );
};

export const selectMe = state => state[key];
